import { lazy, Suspense, Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import MainLayout from 'src/layouts/MainLayout/';
import DashboardLayout from 'src/layouts/DashboardLayout/';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';
import AdminGuard from './components/AdminGuard';

const routesConfig = [
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/errors/NotFoundView')),
  },
  {
    exact: true,
    layout: MainLayout,
    guard: AuthGuard,
    path: '/event/:eventSlug/register',
    component: lazy(() => import('src/views/event/EventRegisterView')),
  },
  // {
  //   exact: true,
  //   layout: DashboardLayout,
  //   guard: AuthGuard,
  //   path: '/create-event',
  //   component: lazy(() => import('src/views/event/EventCreateView')),
  // },
  // {
  //   exact: true,
  //   layout: MainLayout,
  //   path: '/home',
  //   component: lazy(() => import('src/views/home/HomeView')),
  // },
  {
    exact: true,
    layout: MainLayout,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView')),
  },
  {
    exact: true,
    layout: MainLayout,
    guard: GuestGuard,
    path: '/signup',
    component: lazy(() => import('src/views/auth/RegisterView')),
  },
  {
    exact: true,
    layout: DashboardLayout,
    guard: AdminGuard,
    path: '/demo',
    component: lazy(() => import('src/views/testing')),
  },
  {
    path: '/user',
    guard: AuthGuard,
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/user/account',
        component: lazy(() => import('src/views/account/AccountView')),
      },
      {
        exact: true,
        path: '/user/event/list',
        component: lazy(() => import('src/views/event/EventListView')),
      },
      {
        exact: true,
        path: '/user/event/create-event',
        component: lazy(() => import('src/views/event/EventCreateView')),
      },
      {
        exact: true,
        path: '/user/event/:eventSlug/',
        component: lazy(() => import('src/views/event/EventManagementView')),
      },
      {
        exact: true,
        path: '/user/event/:eventSlug/edit',
        component: lazy(() => import('src/views/event/EventEditView')),
      },
      {
        exact: true,
        path: '/user/event',
        component: () => <Redirect to="/app/event/list" />,
      },
      {
        exact: true,
        path: '/user/event/:eventSlug/categories',
        component: lazy(() => import('src/views/category/CategoryView')),
      },
      {
        exact: true,
        path: '/user/event/:eventSlug/category/create-category',
        component: lazy(() => import('src/views/category/CategoryCreateView')),
      },
    ],
  },
  {
    path: '/app',
    guard: AdminGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/account/AccountView')),
      },

      //* Admin Event Management Routes
      {
        exact: true,
        path: '/app/event/list',
        component: lazy(() => import('src/views/event/EventListView')),
      },
      {
        exact: true,
        path: '/app/event/create-event',
        component: lazy(() => import('src/views/event/EventCreateView')),
      },
      {
        exact: true,
        path: '/app/event/:eventSlug/',
        component: lazy(() => import('src/views/event/EventManagementView')),
      },
      {
        exact: true,
        path: '/app/event/:eventSlug/edit',
        component: lazy(() => import('src/views/event/EventEditView')),
      },
      {
        exact: true,
        path: '/app/event',
        component: () => <Redirect to="/app/event/list" />,
      },
      {
        exact: true,
        path: '/app/event/:eventSlug/categories',
        component: lazy(() => import('src/views/category/CategoryView')),
      },
      {
        exact: true,
        path: '/app/event/:eventSlug/category/create-category',
        component: lazy(() => import('src/views/category/CategoryCreateView')),
      },
      //* Admin User Management Routes
      {
        exact: true,
        path: '/app/users',
        component: lazy(() => import('src/views/admin/UserListView')),
      },
      {
        exact: true,
        path: '/app/users/:profileNumber/edit',
        component: lazy(() => import('src/views/admin/UserEditView')),
      },
      {
        exact: true,
        path: '/app/users/:profileNumber',
        component: lazy(() => import('src/views/admin/UserProfileView')),
      },
    ],
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/',
        component: lazy(() => import('src/views/home/HomeView')),
      },
      {
        exact: true,
        path: '/event/:eventSlug',
        component: lazy(() => import('src/views/event/EventDetailsView')),
      },
      {
        component: () => <Redirect to="/404" />,
      },
    ],
  },
];

function renderRoutes(routes) {
  return routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? renderRoutes(route.routes) : <Component {...props} />}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;
}

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
